import React, { useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import PagesModule from "modules/pages";
import useHash from "hooks/useHash";

import Header from "components/Header";
import Footer from "components/Footer";

const DEFAULT_OPTIONS = {
  withHeader: true,
  withFooter: true,
};

const pageLayout = (options) => (Component) => {
  return connect(
    (state) => ({
      common: state.pages.common,
    }),
    {
      onCommon: PagesModule.common,
    }
  )((props) => {
    const config = { ...DEFAULT_OPTIONS, ...options };
    const { withHeader, withFooter } = config;
    const { common, onCommon } = props;

    const [hash, setHash] = useHash();

    useEffect(() => {
      if (!common) onCommon();
    }, []);

    return (
      <div className="wrapper">
        {withHeader && <Header socials={common?.socialLinks} hash={hash} />}
        <Component {...props} setHash={setHash} />
        {/* <Component {...props} /> */}
        {withFooter && <Footer socials={common?.socialLinks} />}
      </div>
    );
  });
};

export default pageLayout;
